import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiShield } = FiIcons;

const BeforeAfter = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-black text-center mb-16">Vom Chaos zur Systemklarheit</h2>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-white p-10 rounded-2xl shadow-sm border-t-4 border-red-500">
              <div className="flex items-center mb-6">
                <SafeIcon icon={FiAlertTriangle} className="text-3xl text-red-500 mr-4" />
                <h3 className="text-2xl font-bold">Ohne Architektur</h3>
              </div>
              <ul className="space-y-6 text-gray-600">
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">–</span>
                  Viele Tools, die nicht ineinandergreifen
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">–</span>
                  Fehleranfällige manuelle Übergaben
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">–</span>
                  Hoher Zeitverlust durch Prozessbrüche
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">–</span>
                  Automatisierung scheitert an fehlender Logik
                </li>
              </ul>
            </div>

            <div className="bg-white p-10 rounded-2xl shadow-sm border-t-4 border-azure-600">
              <div className="flex items-center mb-6">
                <SafeIcon icon={FiShield} className="text-3xl text-azure-600 mr-4" />
                <h3 className="text-2xl font-bold">Mit K³ Architektur</h3>
              </div>
              <ul className="space-y-6 text-gray-600">
                <li className="flex items-start">
                  <span className="text-azure-600 font-bold mr-3">+</span>
                  Klare, dokumentierte Prozesse
                </li>
                <li className="flex items-start">
                  <span className="text-azure-600 font-bold mr-3">+</span>
                  Definierte, saubere Schnittstellen
                </li>
                <li className="flex items-start">
                  <span className="text-azure-600 font-bold mr-3">+</span>
                  Kontrollierte & skalierbare Automatisierung
                </li>
                <li className="flex items-start">
                  <span className="text-azure-600 font-bold mr-3">+</span>
                  Stabilität durch Systemreife
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;